<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="pa-3">
          <v-layout row wrap pb-4>
            <v-flex md4 class="pr-2">
              <v-text-field
                v-model="searchTable"
                append-icon="search"
                label="Search by Passport No"
                single-line
                hide-details
                outline
              ></v-text-field>
            </v-flex>

            <v-flex md4>
              <v-autocomplete
                label="Company"
                v-model="reportFilters.employer_id"
                :items="
                  getTV(employers, {
                    textField: 'name',
                    valueField: 'id',
                    isDeselect: false,
                  })
                "
                hide-details
                hide-selected
                item-text="text"
                item-value="value"
                outline
                @change="onCompanyChanged"
                clearable
                @click:clear="onClearCompany"
              >
              </v-autocomplete>
            </v-flex>
            <!-- <v-flex md4 pl-1>
              <v-autocomplete
                label="Visa Number"
                v-model="reportFilters.visa_number_id"
                :items="visaNumbersTV"
                hide-details
                hide-selected
                item-text="text"
                item-value="value"
                outline
                clearable
                @click:clear="onClearVisaNumber"
              >
              </v-autocomplete>
            </v-flex> -->
            <v-flex md6 class="text-xs-right">
              <!-- <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="primary"
                    fab
                    small
                    dark
                    @click="isSearchModal = true"
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>
                <span>Advance Search</span>
              </v-tooltip> -->
            </v-flex>
          </v-layout>

          <!-- <content-loader v-if="isLoadingContent"></content-loader> -->
          <list-loader v-if="isLoadingContent"></list-loader>

          <div class="simple-table-container" id="daily-expense-report" v-else>
            <div class="hidden-screen-only report-header text-center">
              <div class="head">
                {{ settings && settings.company_name }}
              </div>
              <div class="address">
                {{ settings && settings.company_address }}
              </div>
              <hr />
              <br />
              <div class="title">Passport Wise MOFA Report</div>
              <!-- Company Name: {{ employer.name }}<br /> -->
              <!-- ID Number: {{ employer.id_no }} &nbsp;
              <span v-if="visaNumber.visa_no">Visa Number: {{ visaNumber.visa_no }}</span
              ><br /> -->
            </div>
            <table class="table table-bordered">
              <tr>
                <th>Sl.</th>
                <th>Passport No</th>
                <th>Passenger Name</th>
                <th>Company Name</th>
                <th>MOFA No</th>
                <th>Visa Issue Date</th>
                <th>MOFA Remark</th>
              </tr>
              <tr v-for="(item, index) in reportData" :key="item.id">
                <td>{{ index + 1 }}</td>
                <td>{{ item.passport_number }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.employers___name }}</td>
                <td>{{ item.mofa_number }}</td>
                <td>{{ item.visa_issue_date }}</td>
                <td>{{ item.mofa_notes }}</td>
              </tr>
              <!-- <tr>
                <td colspan="6" class="report-sum text-center">
                  Total Expenses &nbsp;&nbsp; tk. {{ reportSum }}
                </td>
              </tr> -->
            </table>
          </div>
          <v-card-actions>
            <v-btn flat @click="print()">Print</v-btn>
            <!-- <v-btn flat >Explore</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- <v-dialog v-model="isSearchModal" scrollable persistent max-width="500px">
      <AdvanceSearch
        :rfilters="reportFilters"
        @cancelled="isSearchModal = false"
        :hide="['agent']"
      />
    </v-dialog> -->
  </div>
</template>

<script>
import { ContentLoader, ListLoader } from "vue-content-loader";
// import AdvanceSearch from "../../SearchModal";
import { columnSum, getTV } from "../../../mdsir/MdsirUtils";
import * as _ from "underscore";

export default {
  components: {
    ContentLoader,
    ListLoader,
    // AdvanceSearch,
  },
  data: () => ({
    isSearchModal: false,
    isLoadingContent: false,
    invoiceDateMenu: false,
    invoiceDateMenu2: false,
    reportFilters: {
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      employer_id: null,
      visa_number_id: null,
    },
    employers: [],
    visaNumbers: [],
    reportData: [],
    searchTable: "",
  }),

  computed: {
    // reportSum() {
    //   return columnSum(this.reportData, "amount_sum");
    // },
    employer() {
      const { employer_id } = this.reportFilters;
      let employer = {
        name: "",
        id_no: "",
      };

      if (employer_id) {
        employer = this.employers.find((r) => r.id == employer_id);
      }

      return employer;
    },

    visaNumber() {
      const { visa_number_id } = this.reportFilters;
      let visaNums = {
        visa_no: "",
      };

      if (visa_number_id) {
        visaNums = this.visaNumbers.find((r) => r.id == visa_number_id);
      }

      return visaNums;
    },

    visaNumbersTV() {
      const visaNums =
        this.reportFilters && this.reportFilters.employer_id
          ? this.visaNumbers.filter(
              (r) => r.employer_id == this.reportFilters.employer_id
            )
          : this.visaNumbers;
      return getTV(visaNums, {
        textField: "visa_no",
        valueField: "id",
        isDeselect: false,
      });
    },
  },

  watch: {
    reportFilters: {
      handler: _.debounce(function (val, oldVal) {
        this.getDataFromApi();
      }, 1500),
      deep: true,
    },
    // reportFilters: {
    //   handler: function (val, oldVal) {
    //     this.getDataFromApi();
    //   },
    //   deep: true,
    // },
    searchTable: _.debounce(function (newVal) {
      this.reportFilters.passport_number = newVal;
      this.getDataFromApi();
    }, 1500),
  },

  created() {},

  mounted() {
    this.loadFormData();
    this.getDataFromApi();
  },

  methods: {
    getTV: getTV,
    async loadFormData() {
      const employerRes = await this.get("/employers");
      this.employers = employerRes.data.data;
      const visaNoRes = await this.get("/visa_numbers");
      this.visaNumbers = visaNoRes.data.data;
    },
    getDataFromApi() {
      this.isLoadingContent = true;
      this.get("/mofa_report", this.reportFilters).then((response) => {
        this.reportData = response.data;
        this.isLoadingContent = false;
      });
    },
    print() {
      this.$htmlToPaper("daily-expense-report");
    },
    onClearVisaNumber(cl) {
      this.reportFilters.visa_number_id = null;
    },
    onCompanyChanged() {
      this.reportFilters.visa_number_id = null;
    },
    onClearCompany() {
      this.reportFilters.employer_id = null;
    },
  },

  beforeDestroy() {},
};
</script>

<style scoped>
.simple-table-container {
  overflow: auto;
}
.table {
  border-collapse: collapse;
  width: 100%;
}
.table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #bebebe;
}

.table td,
.table th {
  border: 1px solid #ddd;
  padding: 8px;
}

.table td.report-sum {
  padding: 6px;
  text-align: center;
  background-color: #0f0f0f0e;
  font-size: 20px;
  font-weight: bold;
}
</style>
